import _ from 'lodash';
import React,{useContext, useState} from 'react';

import {Row,Col, Table} from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';

import Utils from '../Utils';

import UserContext from './../contexts/UserContext';
import BuyNowPackage from './BuyNowPackage';

const MainHeader = (props) => {
  
  const [ pkgData, setPkgData] = useState(false);
  const [showPlan, setShowPlan] = useState(false);
  const {logout, checkPkgValidity} = useContext(UserContext);
  const userData = Utils.getUserData();

  const [isActive, setActive] = useState(false);

  const handleUser = () => {
    axios.get(Utils.apiUrl(`Package/getUserLicense`), Utils.apiHeaders())
      .then(res => {
        setPkgData(res.data.data);
      })
      .catch(err => console.log("License Error : ",  err));
    setActive(!isActive);
  };

  const handleBuild = (e) => {    
    
    const isAllowed = (validity) => {
      
      if(!validity.validity) Utils.confirmBuyNow(validity.message);
      else window.location.href = process.env.PUBLIC_URL + '/builder';
    
    }

    checkPkgValidity(isAllowed);
  }

  return <Row>
    <Col className="logotxt text-left pt-2 pb-2 logoheader">
      <a href='/'><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} title="Back to Home" alt="best pdf to scorm converter" className="img-fluid logo bg-mycolor" /></a>            
      {Utils.isLoggedIn() && <>
        <nav className="topNav">
          <ul>
            <li onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/password`;}}>
              <span className="txt">Change Password</span>
              <span className="icon key"></span>
            </li>
            <li onClick={handleBuild}>
              <span className="txt">Build Your SVASU</span>
              <span className="icon list-ul"></span>
            </li>
            <li onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/myorders`;}}>
              <span className="txt">My Orders</span>
              <span className="icon shopping-cart"></span>
            </li>
            <li onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/scorms`;}}>
              <span className="txt">My SVASU</span>
              <span className="icon book"></span>
            </li>
            <li onClick={handleUser} id="unm" className={isActive ? 'user active': 'user'} >
              <span className="icon"></span>
              <div className="user-name"><span className="useWelcome">Welcome</span><br />{_.compact([userData.fname, userData.lname]).join(' ')}!</div>
              <div className="ddac ddacNoCursor" >
                  <Table responsive="sm" borderless>
                    <tbody>
                      {pkgData.package && <><tr className="menu-pkg">
                          <td className="label"> Package</td>
                          <td className='text-center'>:</td>
                          <td className="text-left content"> {pkgData.package}</td>
                        </tr>
                        {parseInt(pkgData.cloud) === 1 && <tr className="menu-pkg">
                          <td className="label"> Size Left </td>
                          <td  className='text-center'>:</td>
                          <td className="text-left content" title={(pkgData.total_size - pkgData.used_size).toFixed(2) + ' GB'}> {Math.ceil(pkgData.total_size - pkgData.used_size)} / {pkgData.total_size} GB</td>
                        </tr>
                        }
                         {parseInt(pkgData.cloud) === 1 && <tr className="menu-pkg">
                          <td className="label"> Type</td>
                          <td  className='text-center'>:</td>
                          <td className="text-left content" title={pkgData.cloud ? 'With Cloud' : 'Without Cloud'}>{pkgData.cloud ? 'With Cloud' : 'Without Cloud'}</td>
                        </tr>
                        }
                        <tr className="menu-pkg">
                          <td className="label"> Valid Till</td>
                          <td  className='text-center'>:</td>
                          <td className="text-left content"> {moment(pkgData.due_date).format('YYYY-MM-DD')}</td>
                        </tr>
                      </>}
                      <tr className="td-hr">
                          <td colSpan={3}>
                            <span className="logout btn btn-sm btn-dark " onClick={setShowPlan}>{pkgData.package ? 'Upgrade Plan' : 'Buy Plan'}</span>
                          </td>                  
                        </tr>
                      <tr >
                        <td colSpan={3} style={{paddingBottom:"1px"}}>
                          <span className="logout btn btn-sm btn-warning" onClick={() => logout(()=>{window.location.reload();})}>Logout</span>                
                        </td>
                      </tr>
                    </tbody>
                  </Table>
              </div>
            </li>
          </ul>
        </nav>
        {showPlan && <BuyNowPackage onHide={setShowPlan} />}
      </>}
    </Col>    
  </Row>;
}

export default MainHeader;